import { useEffect, useState } from 'react';

export const useScriptInjectRetry = ({
  scriptUrl,
  successJudge,
  loadAttemptsLimit = 3,
  scriptOptions = {},
}: {
  scriptUrl: string;
  successJudge: () => boolean;
  loadAttemptsLimit?: number;
  scriptOptions?: {
    onload?: Function;
    onabort?: Function;
    onerror?: Function;
  };
}) => {
  const { onload, onabort, onerror } = scriptOptions;
  const [loadAttempts, setLoadAttempts] = useState(0);

  useEffect(() => {
    if (!successJudge() && loadAttempts < loadAttemptsLimit) {
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptUrl;

      script.onload = () => {
        onload?.();
      };
      script.onabort = () => {
        onabort?.();
      };
      script.onerror = () => {
        onerror?.();
        setLoadAttempts(loadAttempts + 1);
      };

      document.body.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadAttempts, loadAttemptsLimit, scriptUrl]);
};
